import React from 'react'
import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Bar } from 'react-chartjs-2'
import moment from 'moment'
// Side effect: registers the chart.js parts the dashboards use
import '../../userPages/dashboard/managerOverview/overviewTheme'
import { WidgetFrame, WidgetUnavailable } from './WidgetFrame'
import { makeChartOptions } from '../wallboardTheme'

// Charts get an explicit pixel height (never flex) — a flexible-height parent
// makes the chart.js canvas resize-loop. The grid passes each widget the
// pixel height of its cell; ~76px covers the frame header and padding.
const chartHeight = (cellPx) => Math.max((cellPx ?? 260) - 76, 100)

export const ShiftsTrendWidget = ({ data, cellPx }) => {
  const { viz } = useTheme().palette
  const trend = data?.shiftsTrend
  return (
    <WidgetFrame title="Shifts per week" accent={viz.series}>
      {!trend || trend.error ? (
        <WidgetUnavailable />
      ) : (
        <Box sx={{ position: 'relative', height: chartHeight(cellPx) }}>
          <Bar
            data={{
              labels: trend.map((week) => moment(week.weekStart).format('D MMM')),
              datasets: [
                {
                  data: trend.map((week) => week.count),
                  backgroundColor: viz.series,
                  borderRadius: 4,
                },
              ],
            }}
            options={makeChartOptions(viz)}
          />
        </Box>
      )}
    </WidgetFrame>
  )
}

export const EpcrTrendWidget = ({ data, cellPx }) => {
  const { viz } = useTheme().palette
  const stats = data?.epcrStats
  return (
    <WidgetFrame title="Patient records per month" accent={viz.series}>
      {!stats || stats.error ? (
        <WidgetUnavailable />
      ) : (
        <Box sx={{ position: 'relative', height: chartHeight(cellPx) }}>
          <Bar
            data={{
              labels: stats.byMonth.map((month) =>
                moment(month.month, 'YYYY-MM').format('MMM'),
              ),
              datasets: [
                {
                  data: stats.byMonth.map((month) => month.count),
                  backgroundColor: viz.series,
                  borderRadius: 4,
                },
              ],
            }}
            options={makeChartOptions(viz)}
          />
        </Box>
      )}
    </WidgetFrame>
  )
}
